"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkin_en_us = void 0;
function checkin_en_us() {
    return {
        "common.dismiss": "OK",
        "common.refresh": "Refresh",
        "common.ok": "OK",
        "common.close": "Close",
        "common.upload": "upload",
        "common.uploading": "uploading...",
        "notifications.notifications": "Notifications",
        "notifications.empty": "Over here you can find current notifications. Nothing new right now.",
        "notifications.confirmation.title": "Confirmation",
        "notifications.warning.title": "Warning",
        "notifications.error.title": "Error",
        "notifications.error.message": "An error occurred!",
        "notifications.success.title": "Success",
        "loading.app": "Loading Check-In App",
        "loading.form": "Loading Form",
        "errors.generic": "Sorry, an error occured",
        "errors.invalidmail": "Please enter a valid e-mail address",
        "errors.invalidurl": "Please enter a valid URL",
        "errors.form.missingproperty": "Missing Input",
        "errors.http.400": "The request was invalid",
        "errors.http.401": "You are not logged in",
        "errors.http.403": "Sorry, you don't have access to this resource",
        "errors.http.404": "Sorry, the requested resource does not exist",
        "errors.http.409": "The resource exists already",
        "errors.http.500": "Something went wrong",
        "errors.http.503": "The service is not available at this moment",
        "errors.user.email_already_exists": "This E-Mail is already registered.",
        "errors.user.invalid_password_uppercasemissing": "Invalid Password: Uppercase character is missing",
        "errors.user.invalid_password_lowercasemissing": "Invalid Password: Lowercase character is missing",
        "errors.user.invalid_password_notatleast8characterslong": "Invalid Password: Please provide at least 8 characters",
        "errors.user.invalid_password_nospecialcharacter": "Invalid Password: Please provide a special character like ! ? # or spaces",
        "errors.user.user_not_found": "User not found",
        "errors.user.invalid_password": "Wrong Password",
        "components.list.emptymessage": "No data found",
        "components.loader.loadingdata": "Loading data..."
    };
}
exports.checkin_en_us = checkin_en_us;
